<div class="container-fluid mt-4">
<div class="row" *ngIf="!isSocietyData">
    <!-- <app-navigation></app-navigation> -->
    <!-- <app-sidebar></app-sidebar> -->
    <div class="card">
      <div class="card-body">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <div class="d-flex align-items-center justify-content-between">
                <h5 class="m-0">Cooperative Societies</h5>
            </div>
            
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                  <label class="form-label">Society Type<span class="text-danger">*</span></label>
                  <select class="form-control" [(ngModel)]="selectedSocietyType">
                    <option value="" disabled selected>Select Society Type</option>
                    <option *ngFor="let data of societyTypeList" [value]="data.id">
                      {{ data.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2 d-flex align-items-end">
                  <button type="button" class="btn btn-primary" (click)="getReport()">Get Report</button>
                </div>
              </div>
        </div>
        </div>
       
        </div>
      </div>
    </div>
    
    <app-footer></app-footer>
</div>
<div class="row" *ngIf="isSocietyData">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
            
          <div class="d-flex align-items-center justify-content-between">
            <button type="button" class="btn btn-secondary" (click)="back()">Back</button>
            <button type="button" class="btn btn-primary" onclick="window.print()">Print</button>
            </div>
          
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12" style="text-align: center;">
                <h5 class="mb-2">Department of Cooperation Himachal Pradesh</h5>
            </div>
            <hr>
            <div class="col-md-12" style="text-align: center;">
                <h5>{{listName}}</h5>
            </div>
            <div class="col-md-12" style="text-align: center;">
                As on : {{ dateVariable | date: 'dd-MM-yyyy hh:mm a'}}
            </div>
            <hr>
            <div class="col-md-12">
                <div class="full-page-table">
                    <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
                      [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                       
                       [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
                      [loadingIndicator]="loading">
                      <ngx-datatable-column name="#" [sortable]="false">
                        <!-- Custom Template for Action column -->
                        <ng-template let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                          <span>{{
                            (page.pageNumber - 0) * page.pageSize + rowIndex + 1
                            }}</span>
                        </ng-template>
                      </ngx-datatable-column>
          
                      <ngx-datatable-column [sortable]="true" *ngFor="let column of columns" [name]="column.name"
                        [prop]="column.prop">
                        <!-- Custom Template for Action column -->
                        <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
                          {{ value }}
                        </ng-template>
                      </ngx-datatable-column>
                    </ngx-datatable>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</div>